import { observer } from "mobx-react-lite";

import { usePlayground } from "../playground-store";

import Banner from "@/components/ui/banner";
import { getGeminiPromptWarning } from "@/utils/geminiPromptWarnings";

const GeminiPromptWarning = () => {
  const playground = usePlayground();
  const warning = getGeminiPromptWarning(playground.blueprintWithSnippetOverrides);

  if (playground.isSnippet || !warning) {
    return null;
  }

  return (
    <Banner role="status" className="m-2" type="warning">
      {warning}
    </Banner>
  );
};

export default observer(GeminiPromptWarning);
